





























import {Component, Vue, Model, Prop} from "vue-property-decorator";
import request from "@/util/request";
import _ from 'lodash';


@Component
export default class pdfExport extends Vue {
    @Model("change", {type: Object})
    readonly value !: {
        name: string,
        id: number,
    };


    @Prop()
    parentId!: string;
    @Prop()
    name!: string;

    pdf = {
        id: null,
        name: null,
    }

    showCanvas = false;

    created() {

    }

    get pdfId() {
        return this.parentId;
    }

    get pdfName() {
        return this.name;
    }


    get excelName() {
        return this.name;
    }

    startCreateExcel() {

        if (this.pdfId) {

            this.HtmlExportToPdf(this.pdfId, this.pdfName);
        }
    }


    getBase64(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
    }


    netGetPdfBuffer(tableId, name) {

        var cntElem = $('#' + tableId)[0];
        var shareContent = cntElem;//需要截图的包裹的（原生的）DOM 对象
        var width = shareContent.offsetWidth; //获取dom 宽度
        var height = shareContent.offsetHeight; //获取dom 高度
        var canvas = document.createElement("canvas"); //创建一个canvas节点
        var scale = 2; //定义任意放大倍数 支持小数
        canvas.width = width * scale; //定义canvas 宽度 * 缩放
        canvas.height = height * scale; //定义canvas高度 *缩放
        let content = canvas.getContext("2d");
        // @ts-ignore
        content.scale(scale, scale); //获取context,设置scale
        var rect = cntElem.getBoundingClientRect();//获取元素相对于视察的偏移量
        // // @ts-ignore
        // content.translate(-rect.left, -rect.top);//设置context位置，值为相对于视窗的偏移量负值，让图片复位

        var opts = {
            scale: 1, // 添加的scale 参数
            canvas: canvas, //自定义 canvas
            // logging: true, //日志开关，便于查看html2canvas的内部执行流程
            width: width, //dom 原始宽度
            height: height,
            useCORS: true,// 【重要】开启跨域配置
            background: "#fff"
        };

        var that = this;
        // @ts-ignore
        html2canvas(cntElem, opts).then(function (canvas) {
            // that.showCanvas = true;
            // setTimeout(function () {
            //     window.document.getElementById('targetCanvas').appendChild(canvas);
            // }, 100)
            var context = canvas.getContext('2d');
            // 【重要】关闭抗锯齿
            context.mozImageSmoothingEnabled = false;
            context.webkitImageSmoothingEnabled = false;
            context.msImageSmoothingEnabled = false;
            context.imageSmoothingEnabled = false;

            var contentWidth = canvas.width;
            var contentHeight = canvas.height;
            //一页pdf显示html页面生成的canvas高度;
            // var A4width=592.28;
            var A4width = 592.28;

            var pageHeight = contentWidth / A4width * 841.89;
            //未生成pdf的html页面高度
            var leftHeight = contentHeight;
            //页面偏移
            var position = 0;
            //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
            var imgWidth = 592.28;
            var imgHeight = imgWidth / contentWidth * contentHeight;

            var pageData = canvas.toDataURL('image/jpeg', 1.0);

            // @ts-ignore
            var pdf = new jsPDF('', 'pt', 'a4');

            //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
            //当内容未超过pdf一页显示的范围，无需分页
            if (leftHeight < pageHeight) {
                pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
            } else {
                while (leftHeight > 0) {
                    pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                    leftHeight -= pageHeight;
                    position -= 841.89;
                    //避免添加空白页
                    if (leftHeight > 0) {
                        pdf.addPage();
                    }
                }
            }
            pdf.save(name);
        })
    }

    HtmlExportToPdf(tableId?: string, name?: string) {
        // this.getPdfBuffer(tableId,this.tableLabel.name);
        this.netGetPdfBuffer(tableId, name);
    }


}
